(function() {
    'use strict';

    angular.module('swif.patrimoine')
        .factory('swifPatrimoineContractService', swifPatrimoineContractService);

    /**
        * @ngdoc service
        * @name swif.patrimoine.swifPatrimoineContractService
        * @requires swif.framework.swifFrameworkService
        * @description gestion des contracts
    **/
    function swifPatrimoineContractService($q, swif, openstc, swifRecurrenceService) {
        'ngInject';
        var serviceInter = openstc;
        var interService = openstc;
        var recurrenceSrv = swifRecurrenceService;
        /**
        CONTRACT:
            model._propertyStates: service.task.getPropertyStates()
            model._siteControls: one2many
            model._controls = controls;

        */

        var service = {};
        service.resolveData = function() {
            return swif.route.initializedAndAuthenticated().then(function() {
                var deferred = $q.defer();
                var data = {};
                data.title = 'Controls-Contracts';
                swif.collections.collections['contracts'] = undefined;

                service.createCollection().then(function(collection) {
                    data.contracts = collection;
                    var promises = [];
                    if (collection.currentItem) {
                        promises.push(service.createOccurrencesCollection(collection.currentItem)
                            .then(function(occurrences) {
                                data.occurrences = occurrences;
                            }));
                        promises.push(service.createTasksCollection(collection.currentItem)
                            .then(function(tasks) {
                                data.tasks = tasks;
                            }));
                    }
                    $q.all(promises).then(function() {
                        deferred.resolve(data);
                    });
                });
                return deferred.promise;
            });
        };
        service.collection_ids = {
            patrimoine_contract: 'contracts',
            patrimoine_contract_task: 'contract-occurrences',
            task: 'contract-tasks'
        };
        service.recurrence = {};
        service.recurrence.loading = {
            tasks: {}
        };
        service.task = {};

        service.swif = swif;
        service.getCollection = function() {
            return swif.collections.getCollection(
                service.collection_ids.patrimoine_contract
            );
        };

        service.getOccurrencesCollection = function() {
            return swif.collections.getCollection(
                service.collection_ids.patrimoine_contract_task
            );
        };
        service.getTasksCollection = function() {
            return swif.collections.getCollection(
                service.collection_ids.task
            );
        };

        service.createCollection = function(filter) {
            if (filter === undefined) {
                filter = {};
            }
            swif.data.sortOn(filter, 'id', 'DESC');
            return swif.collections.createOrUpdate(
                service.collection_ids.patrimoine_contract,
                'patrimoine_contract',
                filter, {
                    location: true
                }
            );
        };

        service.createOccurrencesCollection = function(contract) {
            var filter = {};
            if (contract) {
                swif.data.addExtraFilter(filter, 'from_contract', 'project_id.id', '=', contract.id);
                swif.data.addExtraFilter(filter, 'from_contract', 'project_id.project_type', '=', 'contract');
                swif.data.addExtraFilter(filter, 'from_contract', '|');
                swif.data.addExtraFilter(filter, 'from_contract', 'site_ids', '!=', false);
                swif.data.addExtraFilter(filter, 'from_contract', 'equipment_ids', '!=', false);
            }
            swif.message.loading(service.recurrence.loading.tasks);
            return swif.collections.createOrUpdate(
                service.collection_ids.patrimoine_contract_task,
                'patrimoine_contract_task',
                filter
            ).then(function(collection) {
                swif.message.loading(service.recurrence.loading.tasks, 'ok');
                return collection;
            }, function() {
                swif.message.loading(service.recurrence.loading.tasks, 'ko');
            });
        };
        service.createTasksCollection = function(contract) {
            var filter = {};
            if (contract) {
                swif.data.addExtraFilter(filter, 'from_contract', 'project_id.id', '=', contract.id);
                swif.data.addExtraFilter(filter, 'from_contract', 'project_id.project_type', '=', 'contract');
                swif.data.addExtraFilter(filter, 'from_contract', 'site_ids', '=', false);
                swif.data.addExtraFilter(filter, 'from_contract', 'equipment_ids', '=', false);
            }
            swif.message.loading(service.recurrence.loading.tasks);
            return swif.collections.createOrUpdate(
                service.collection_ids.task,
                'task',
                filter
            );
        };

        service.getSpecialFilters = function() {
            return {
                controls: {
                    id: 'contracts',
                    label: 'Contracts without controls',
                    active: false,
                    length: 0,
                    extraFilter: [
                        ['is_contract', '=', true],
                        ['is_control', '=', false]
                    ]
                },
                contracts: {
                    id: 'controls',
                    label: 'Controls without contracts',
                    active: false,
                    length: 0,
                    extraFilter: [
                        ['is_contract', '=', false],
                        ['is_control', '=', true]
                    ]
                },
                controlsContracts: {
                    id: 'controlsContracts',
                    label: 'Controls with contracts',
                    active: false,
                    length: 0,
                    extraFilter: [
                        ['is_contract', '=', true],
                        ['is_control', '=', true]
                    ]
                }
            };
        };

        service.refreshCurrentContract = function() {
            var collection = service.getCollection();
            if (collection.currentItem) {
                collection.updateItem(collection.currentItem);
            }
        };

        // @param: categ_ids (Array of IDS): consumable categories,
        // used to fiter the properties to fetch from the server
        // @return: defer of the get() performed to the server
        service.fetchPropertiesFromCategories = function(categ_ids) {
            var filter = {
                fields: ['name', 'site_id', 'equipment_id']
            };
            swif.data.setLimit(filter, 0);
            if (categ_ids) {
                swif.data.addFilter(filter, 'category_id', 'in', categ_ids);
            }
            return swif.data.get('patrimoine_property', undefined, filter);
        };

        service.recurrence.getTasksCollection = function() {
            return swif.collections.getCollection('recurrente_task_occurrences');
        };

        service.recurrence.createTasksCollection = function(recur) {
            var filter = {};
            if (recur) {
                swif.data.addExtraFilter(filter, 'from_recur', 'recurrence_id.id', '=', recur.id);
            }
            return swif.collections.createOrUpdate(
                'recurrente_task_occurrences',
                'patrimoine_contract_task',
                filter
            );
        };

        service.recurrence.sanitizeOccurrence = function(recur) {
            // sanitize model data before creating / saving it
            var sanitizeItem = function(item) {
                return {
                    id: item.id,
                    site_id: item.site_id ? item.site_id[0] : false,
                    site_property_ids: [
                        [6, 0, item.site_property_ids || []]
                    ]
                };
            };
            if (recur) {
                if (recur._siteControls) {
                    recur.site_ctrl_tmpl_ids = swif.data.prepareOne2manyValues(
                        recur.site_ctrl_tmpl_ids,
                        recur._siteControls,
                        sanitizeItem
                    );
                }

                if (recur._scheduleLater) {
                    recur.partner_id = false;
                    recur.partner_address = false;
                    recur.user_id = false;
                    recur.team_id = false;
                }

                var contracts = service.getCollection();
                if (contracts.currentItem) {
                    var contract = contracts.currentItem;
                    if (!recur.name) {
                        recur.name = contract.name;
                    }
                    if (!recur.intervention_id) {
                        recur.intervention_id = [contract.id, contract.name];
                    }
                }
            }

            return true;
        };

        service.recurrence.sanitizeRecurrence = function(recurrence) {
            var ret = angular.copy(recurrence);

            return swif.data.getModelFields(ret._type).then(function(fields) {
                _.forOwn(ret, function(value, key) {
                    if (!_.has(fields, key)) {
                        delete ret[key];
                    }
                });
                return ret;
            });
        };

        service.recurrence.generateDates = function(recurrence) {
            swif.message.loading(service.recurrence.loading.tasks);
            // @TODO: ensure the older tasks will be removed when saving modal,
            // if they had 'delete' action available
            return service.recurrence.sanitizeRecurrence(recurrence)
                .then(function(recur) {
                    recur._type = recurrence._type;
                    var format_occurrence = angular.copy(recur);
                    delete format_occurrence.id;
                    format_occurrence._type = 'patrimoine_contract_task';
                    // remove non-fields from Object, to fluidify network
                    return recurrenceSrv.getDates(recur, format_occurrence)
                        .then(function(data) {
                            // remove old tasks (store them until we call _saveRecurrence())
                            recurrence.deletedOccurrences = _.remove(recurrence.occurrences, function(elt) {
                                return !_.contains(['done', 'cancelled'], elt.state);
                            });
                            recurrence.occurrences = _.union(recurrence.occurrences, recur.occurrences);
                            swif.message.loading(service.recurrence.loading.tasks, 'ok');
                            return data;
                        }, function() {
                            swif.message.loading(service.recurrence.loading.tasks, 'ko');
                        });
                });
        };

        service.task.getWorksCollection = function() {
            return swif.collections.getCollection('task_works');
        };

        service.task.createControlsCollection = function(task) {
            var filter = {};
            if (task) {
                swif.data.addExtraFilter(filter, 'from_task', 'control_task_id.id', '=', task.id);
            }
            return swif.data.get(
                'patrimoine_site_control',
                undefined,
                filter
            );
        };

        // compute and attach openstc.site.properties.survey on each related work model
        service.task.fetchSitePropertiesOnWorks = function(controls) {
            // first, fetch ALL surveys found from controls IN ONE CALL
            // @TOFIX: i don't use 2nd param because, when odoo returns 1 result,
            // swif returns a single item instead of an Array
            return swif.data.get(
                    'patrimoine_property_survey',
                    undefined, {
                        domain: [
                            ['site_control_id', '=', _.pluck(controls, 'id')]
                        ]
                    }
                )
                .then(function(result) {
                    // i begin to index each survey by its site_control_id
                    var surveys = {};
                    _.forEach(result, function(survey) {
                        var key = survey.site_control_id ? survey.site_control_id[0] : 0;
                        if (!surveys[key]) {
                            surveys[key] = [];
                        }
                        surveys[key].push(survey);
                    });
                    // then, displatch the related surveys to the controls
                    _.forEach(controls, function(control) {
                        control._surveys = [];
                        if (surveys[control.id]) {
                            control._surveys = surveys[control.id];
                        }
                    });
                    return controls;
                });
        };

        service.task.saveWorkAndSurveys = function(work) {
            var ret = $q.defer();
            if (work._surveys) {
                work.site_property_survey_ids = [];
                _.forEach(work._surveys, function(survey) {
                    var val = {
                        new_state: survey.new_state,
                        done: survey.done,
                        notes: survey.notes
                    };
                    work.site_property_survey_ids.push([1, survey.id, val]);
                });
                ret = swif.data.save('patrimoine_site_control', work.id, work, {
                    contract: true
                });
            } else {
                ret.resolve();
                ret = ret.promise;
            }
            return ret;
        };
        service.task.saveSurveys = function(control) {
            var ret = $q.defer();
            if (control._surveys) {
                control.site_property_survey_ids = [];
                _.forEach(control._surveys, function(survey) {
                    var val = {
                        new_state: survey.new_state,
                        done: survey.done,
                        notes: survey.notes
                    };
                    control.site_property_survey_ids.push([1, survey.id, val]);
                });
                ret = swif.data.save('patrimoine_site_control', control.id, control, {
                    contract: true
                });
            } else {
                ret.resolve();
                ret = ret.promise;
            }
            return ret;
        };

        service.task.getPropertyStates = function() {
            var ret = [];
            var states = swif.settings.app.contentTypes.patrimoine_property.states;
            _.forEach(states, function(state, key) {
                ret.push({
                    id: key,
                    htmlName: '<span class="label label-' + state.labelclass + '">' + state.title + '</span>',
                    name: state.title
                });
            });
            return ret;
        };

        /*
         * @filter: (Object) form-filter object to update
         * @param: (Object) current model used to compute filters
         * @notes: update the object 'filter' attributes:
         * 'site_property_categ_ids' and 'site_property_ids'
         * directly usable on forms
         * @return (Object): the new filter values, the initial object
         * is not modified
         */
        service.task.getSitesFilters = function(filter, model) {
            //            var ret = angular.copy(filter);
            //            var value = {};
            filter.site_property_categ_ids = {};
            filter.site_property_ids = {};
            if (model.site_ids && !_.isEmpty(model.site_ids)) {
                swif.data.addFilter(
                    filter.site_property_categ_ids,
                    'site_property_ids.site_id',
                    'child_of',
                    model.site_ids
                );
            }
            if (model.equipment_ids && !_.isEmpty(model.equipment_ids)) {
                swif.data.addFilter(
                    filter.site_property_categ_ids,
                    'site_property_ids.equipment_id',
                    'child_of',
                    model.equipment_ids
                );
            }
            if (model.site_id) {
                swif.data.addFilter(
                    filter.site_property_ids, 'site_id', '=', model.site_id[0]
                );
            }
            return filter;
        };

        /*
         * @param initialValues: (Array) current value of site_controls
         * @param newV: (Array) new site_ids value
         * @param oldV: (Array) old site_ids value
         * @return: (Array) new value of the site_controls linked with site_ids
         * with following format: [{_index: site_id, name: 'bla', ...}]
         */
        service.updateSiteControls = function(initialValues, newV, oldV, patrimoine_type) {
            var newValues = [];
            // retrieve removed ids from oldV, and new ids added on newV
            var removed_ids = _.intersection(oldV, _.xor(oldV, newV));
            var new_ids = _.intersection(newV, _.xor(oldV, newV));
            var field = 'site_id';
            if (patrimoine_type === 'patrimoine_equipment') {
                field = 'equipment_id';
            }
            // then, trash the removed items (copy unremoved item to 'newValues')
            _.forEach(initialValues, function(item) {
                if (item._index && !_.contains(removed_ids, item._index)) {
                    newValues.push(item);
                }
            });

            // finally, for each new ids, create a new item
            // (the _index attribute is a site_id, so that we can create / delete items
            // in link with the selected site_ids)
            _.forEach(new_ids, function(new_id) {
                var newObj = {
                    _index: new_id,
                    site_property_ids: []
                };
                // fetch site to retrieve its name
                swif.data.get(patrimoine_type, new_id, {
                        fields: ['name', 'complete_name']
                    })
                    .then(function(data) {
                        newObj[field] = [data.id, data.complete_name || data.name];
                    });
                newValues.push(newObj);
            });
            return newValues;
        };

        service.callback = function(error, data) {
            var collection = service.getCollection();
            if (data.action.id === 'close') {
                collection.updateItem(data.model);
            } else if (data.action.id === 'renew') {
                collection.getItems();
            }
            collection.defaultActionCallback(error, data);
        };

        service.preModal = function(data) {
            service.getCollection().preModal(data);
        };

        service.preValidate = function(data) {
            if (data.action.id === 'renew') {
                // Extract fields
                var params = _.pick(data.model, ["state", "new_description", "new_date_start_order", "new_date_end_order"]);
                data.model.state = 'renew';

                return swif.data
                    .save('patrimoine_contract', data.model.id, params)
                    .then(function () {
                        return swif.data.callKw('patrimoine_contract', 'renew', [[data.model.id]]);
                    });
            } else if (data.action.id === 'close') {
                data.model.state = 'finished';
            } else if (_.contains(['add', 'edit', 'copy'], data.action.id)) {
                // prepare site_control_ids for save
                // update modified items, create added items, remove absent items
                if (data.model._siteControls) {
                    var sanitizeItems = function(item) {
                        return {
                            id: item.id,
                            equipment_id: item.equipment_id ? item.equipment_id[0]: false,
                            site_id: item.site_id ? item.site_id[0] : false,
                            site_property_ids: [
                                [6, 0, item.site_property_ids || []]
                            ]
                        };
                    };

                    data.model.site_ctrl_tmpl_ids = swif.data.prepareOne2manyValues(
                        data.model.site_ctrl_tmpl_ids,
                        data.model._siteControls,
                        sanitizeItems
                    );
                }
            }
            var collection = service.getCollection();
            var ret = collection.preValidate(data);
            return ret;
        };


        service.syncOccurrenceWithRecurrence = function(recurrence, occurrence) {
            occurrence.project_id = recurrence.intervention_id;
            occurrence.recurrence_id = [recurrence.id, ''];
            occurrence.site_ids = recurrence.site_ids;
            occurrence.equipment_ids = recurrence.equipment_ids;
            // _saveOccurrence() will compute the site_control_ids from _siteControls
            occurrence._siteControls = recurrence._siteControls;
            occurrence.user_id = recurrence.user_id;
            occurrence.team_id = recurrence.team_id;
            occurrence.partner_id = recurrence.partner_id;
            occurrence.partner_address = recurrence.partner_address;
            occurrence.notify = recurrence.notify;
            occurrence.patrimoine_is_equipment = recurrence.patrimoine_is_equipment;
            occurrence.service_id = recurrence.service_id;
            occurrence.category_id = recurrence.task_categ_id;
            occurrence.planned_hours = recurrence.planned_hours;
            occurrence.schedule_delay = recurrence.schedule_delay;
            occurrence.notify = recurrence.notify;
        };
        service._saveOccurrences = function(recurrence) {
            // for each occurrences, i create a sanitized task
            // (used with _saveOccurrence() to correctly create surveys, controls, ...)
            _.forEach(recurrence.occurrences, function(occurrence) {
                // complete task using the recurrence values, such as:
                // site_ids, _siteContols, user_id, etc.
                if (!occurrence.id) {
                    service.syncOccurrenceWithRecurrence(recurrence, occurrence);
                }
            });
            var i = 0;
            // recursive method, save each element on the list, on at a time, as a queue system
            var saveOccurrence = function(deferred) {
                if (!deferred) {
                    deferred = $q.defer();
                }
                var occurrence = recurrence.occurrences[i];
                // while it remains bookings to save, recursively call itself
                if (occurrence) {

                    // increment counter for the next recursive call
                    i++;
                    service._saveOccurrence(occurrence)
                        .then(function(data) {
                            if (!occurrence.id && _.isNumber(data.result)) {
                                occurrence.id = data.result;
                            }
                            occurrence._saved = true;
                            deferred.notify({
                                i: i,
                                recurrence: recurrence,
                                occurrence: occurrence
                            });
                            saveOccurrence(deferred);
                        }, function() {
                            // @TODO: (CHECK) should you stop here the defers if an error occurred ?
                            // deferred.reject(booking);
                            service.saved.done += 1;
                            saveOccurrence(deferred);
                        });
                } else {
                    deferred.resolve();
                }
                return deferred.promise;
            };
            return saveOccurrence();

        };

        service._saveRecurrence = function(recurrence) {
            var defer;
            // prepare one2many values for controls templates, and sanitize some data,
            // such as user_id, ...
            service.recurrence.sanitizeOccurrence(recurrence);
            if (_.isNumber(recurrence.id)) {
                var unlinkTaskso2m = [];
                // retrieve possible deleted task_ids (when regenerating dates)
                // build a one2many expression to delete them during save()
                // if user is not able to delete a task, cut the
                _.forEach(recurrence.deletedOccurrences, function(elt) {
                    if (elt.id) {
                        unlinkTaskso2m.push([2, elt.id]);
                    }
                });
                recurrence.occurrence_ids = unlinkTaskso2m;
                var ctx = {
                    'unlink_task_with_children': true
                };
                defer = swif.data.save('openstc_task_recurrence', recurrence.id, recurrence, ctx);
            } else {
                defer = swif.data.create('openstc_task_recurrence', recurrence)
                    .then(function(data) {
                        recurrence.id = data.result;
                    });
            }
            return defer.then(function() {
                return service._saveOccurrences(recurrence);
            });
        };

        service.preModalOccurrence = function(data) {
            var contract = angular.copy(data.model);
            service.getOccurrencesCollection().preModal(data);
            var defaultVals = {
                patrimoine_is_equipment: contract.patrimoine_is_equipment,
                site_ids: contract.site_ids,
                equipment_ids: contract.equipment_ids,
                site_property_categ_ids: contract.site_property_categ_ids,
                service_id: contract.service_id,
                planned_hours: 2
            };
            if (contract.is_contract) {
                defaultVals.date_start = contract.date_start;
                if (defaultVals.date_start) {
                    var dt = defaultVals.date_start + ' 08:00:00';
                    var dtutc = swif.date.getMomentDatetime(dt);
                    defaultVals.date_start = dtutc.format('YYYY-MM-DD HH:mm:00');
                }
                defaultVals.date_end = contract.date;
                defaultVals.recur_length_type = 'until';
                defaultVals.partner_id = contract.partner_id;
                defaultVals.partner_address = contract.partner_address;
            }

            if (data.action.id === 'add_by_recurrence') {
                data.model._recurrence = defaultVals;
                data.model._recurrence._type = 'openstc_task_recurrence';
            } else if (data.action.id === 'add') {
                defaultVals.project_id = [contract.id, contract.name];
                // in this action, we want to create a simple task,
                // all data will be set on _task,
                // because data.model refers to a contract
                data.model._task = defaultVals;
                var propStates = service.task.getPropertyStates();
                data.model._task._propertyStates = propStates;
                data.model.planned_hours = 2;
                if (!data.model.project_id && contract._type === 'patrimoine_contract') {
                    data.model.project_id = [contract.id, contract.name];
                }
            } else if (data.action.id === 'edit') {
                // very very crappy, but allows us to use same modal
                // as the one used on preModalRecurrenteTask,
                // where data.model refers to contract instead of task
                data.model._task = _.omit(data.model, '_task');
            } else if (data.action.id === 'edit_recurrence') {
                data.model._recurrence = {};
                // @tocheck: AS data.model IS a task and not a contract,
                // CHECK that everything in modal is still working
                var recur = data.model.recurrence_id;
                data.model._defer = swif.data.get(
                    'openstc_task_recurrence',
                    recur ? recur[0] : undefined
                ).then(function(result) {
                    data.model._recurrence = result;
                });
            } else if (data.action.id === 'survey' || data.action.id === 'readonly_survey') {
                data.model._propertyStates = service.task.getPropertyStates();
                service.task.createControlsCollection(data.model)
                    .then(function(controls) {
                        //dirty fix for 6714 : equipment_id=false dans certain retour serveur alors que equipment_ids est bien remplie
                        if (data.model.equipment_ids.length>0){
                            angular.forEach(controls, function(control, index) {
                                controls[index].equipment_id = data.model.equipment_names[index];
                            });
                        }
                        service.task.fetchSitePropertiesOnWorks(controls)
                            .then(function() {
                                data.model._controls = controls;
                            });
                        data.model.Workfilters = serviceInter.task.getFilters(data.model, undefined, true);
                    });
            }

        };
        service.notify = {
            reccurrence: {}
        };
        service.preValidateOccurrence = function(data) {
            if (_.contains(['add_by_recurrence', 'edit_recurrence'], data.action.id)) {
                //var recurrence = angular.copy(data.model._recurrence);
                // first, i save the model
                return service._saveRecurrence(data.model._recurrence)
                    .then(function() {
                        service.notify.reccurrence = {};
                        return true;
                    }, function() {
                        service.notify.reccurrence = {};
                        return false;
                    }, function(notify) {
                        service.notify.reccurrence = notify;
                    });
            }
            var task = data.model._task || data.model._recurrence;
            if (_.contains(['edit', 'add'], data.action.id)) {
                if (data.action.id === 'add') {
                    //collection.preValidate + change fields if state done
                    interService.task.preValidate(data);
                }
                var defer = service._saveOccurrence(task);
                /* @TODO: perharps this check is useless,
                 * as recurrence is never edited or created direclty in a regular way,
                 * see if we can remove it (and sanitize preValidate
                 * methods with task and recurrence actions)
                 */
                // only on task actions, i sync date_start, date_end, and hours
                return defer.then(function(ret) {
                    data.result = ret;
                    data.model = task;
                    return true;
                }, function(error) {
                    service.callbackOccurrence(error);
                    return false;
                });
            } else if (_.contains(['survey', 'readonly_survey'], data.action.id)) {
                // when saving a survey, save all works in it,
                // for each work, save its surveys (on its own save())
                var defers = [];
                _.forEach(data.model._controls, function(control) {
                    // before saving the work, compute its surveys data
                    // they are one2many, Odoo expects a specific format
                    defers.push(service.task.saveSurveys(control));
                });
                return $q.all(defers).then(function() {
                    return true;
                });
            } else if (data.action.id === 'finish_survey') {
                return swif.data.callKw(
                    'patrimoine_contract_task',
                    'finishTaskAndSurveys', [
                        [data.model.id]
                    ], {}
                ).then(function() {
                    return true;
                });
            } else {
                // for all standards actions, sanitize data object
                _.merge(data.model, task);
                return service.getOccurrencesCollection().preValidate(data);
            }
            return true;
        };

        service.callbackOccurrence = function(error, data) {
            var collection = service.getOccurrencesCollection();
            var tasks = service.getTasksCollection();
            if (collection) {
                collection.defaultActionCallback(error, data);
                if (_.contains([
                        'survey',
                        'readonly_survey',
                        'finish_survey'
                    ], data.action.id)) {
                    collection.updateItem(data.model);
                }
                if (_.contains([
                        'add_by_recurrence',
                        'edit_recurrence'
                    ], data.action.id)) {
                    collection.getItems();
                }
                if (tasks) {
                    tasks.getItems();
                }
            }
            service.refreshCurrentContract();
        };

        service.preModalTask = function(data) {
            interService.task._preModal(data);
            if (data.action.id === 'attachments') {
                swif.attachment.attachmentPreModal(
                    data,
                    swif.collections.getCollection(service.collection_ids.task)
                );
            }
        };
        service.preValidateTask = function(data) {
            return interService.task.preValidate(data);
        };
        service.callbackTask = function(error, data) {
            if (error) {
                return;
            }
            var tasks = service.getTasksCollection();
            var contracts = service.getCollection();
            interService.task.callbackMessage(error, data);
            interService.task.collectionCallback(tasks, data);
            if (_.contains(['add', 'edit', 'done'], data.action.id)) {
                _.forEach(contracts.items, function(contract) {
                    if (data.model.project_id) {
                        if (contract.id === data.model.project_id[0]) {
                            contracts.updateItem(contract);
                        }
                    }
                });
            }
        };

        service._saveOccurrence = function(occurrence) {
            if (occurrence) {
                serviceInter.task.syncDateEnd(occurrence);
            }
            var contentType = 'patrimoine_contract_task';
            var sanitizeItems = function(item) {
                // first, set the global values of the control
                // no matter the use-case, this valuse will always be set
                var ret = {
                    id: item.id,
                    site_id: item.site_id ? item.site_id[0] : false,
                    site_property_ids: [
                        [6, 0, item.site_property_ids || []]
                    ]
                };
                // when we are on 'done mode', we set the work values and the surveys
                // @TODO: the condition isn't very explicit,
                // we should check the _state.done value instead

                if (item._surveys && !_.isEmpty(item._surveys)) {
                    // try to retrieve work values from the tasks data
                    // as we don't define the schedule on control form
                    ret.hours = occurrence.planned_hours || 0.0;
                    ret.date = occurrence.date_start || false;
                    ret.user_id = occurrence.user_id ? occurrence.user_id[0] : false;
                    ret.team_id = occurrence.team_id ? occurrence.team_id[0] : false;
                    ret.partner_id = occurrence.partner_id ? occurrence.partner_id[0] : false;
                    ret.partner_address = occurrence.partner_address ? occurrence.partner_address[0] : false;
                    ret.notify = occurrence.notity ? occurrence.notify : false;

                    // then, prepare the surveys for the create()
                    ret.site_property_survey_ids = [];
                    _.forEach(item._surveys, function(survey) {
                        var val = {
                            site_property_id: survey.site_property_id[0],
                            new_state: survey.new_state,
                            done: true,
                            notes: survey.notes
                        };
                        ret.site_property_survey_ids.push([0, 0, val]);
                    });
                }
                return ret;
            };
            // first, prepare the site_control_ids value
            if (occurrence._siteControls) {
                var field = 'site_control_ids';
                occurrence[field] = swif.data.prepareOne2manyValues(
                    occurrence[field],
                    occurrence._siteControls,
                    sanitizeItems
                );
            }
            /* then, according to the cases, call the related request:
             * new task already done: create it with 1 patrimony and state 'done'
             * new task: create it
             * existing task: update it
             */
            function createMultipleUserTaskOccurrence(occurrence, done) {
                if (Array.isArray(occurrence.user_id) && Number.isInteger(occurrence.user_id[1])) {
                    // Duplicate task with main attribute when multiple user_ids
                    var user_ids = angular.copy(occurrence.user_id);
                    var dupOccurrence = angular.copy(occurrence); // To not edit original occurence
                    dupOccurrence.user_id = [user_ids.shift(), ''] // Remove first because we will create it after to preserve actual workflow
                    for (const id of user_ids) {
                        var dupTask = angular.copy(dupOccurrence);
                        dupTask.user_id =  [id, ''];
                        // Remove useless attributes for secondary tasks
                        delete dupTask.consumable_request_ids
                        delete dupTask.consumable_asks
                        delete dupTask.consumables
                        delete dupTask.vehicule
                        delete dupTask.equipment_ids
                        delete dupTask.purchase_order
                        delete dupTask.oil_price
                        delete dupTask.oil_qtity
                        delete dupTask.km
                        swif.data.create(
                            contentType,
                            dupTask, {
                                autosetSurveys: !done
                            }
                        );
                    }
                    return dupOccurrence
                };
                return occurrence
            }
            var defer;
            var done = occurrence._state ? occurrence._state.done : false;
            var tocreate = !_.isNumber(occurrence.id);
            if (tocreate && done) {
                // done task: move the select-one value to the many2many field
                // and send the 'report_hours' value through the context
                occurrence.site_ids = occurrence.site1 ? [occurrence.site1[0]] : [];
                occurrence.equipment_ids = occurrence.equipment_id ? [occurrence.equipment_id[0]] : [];
                occurrence.state = 'done';
                occurrence = createMultipleUserTaskOccurrence(occurrence, done)
                defer = swif.data.create(
                    contentType,
                    occurrence
                );
            } else if (tocreate) {
                // set autosetSurveys to True, to autocreate surveys
                // based on the site properties
                occurrence = createMultipleUserTaskOccurrence(occurrence, done)
                defer = swif.data.create(
                    contentType,
                    occurrence, {
                        autosetSurveys: true
                    }
                );
            } else {
                // for 'edit' action, just do a standard save()
                defer = swif.data.save(
                    contentType,
                    occurrence.id,
                    occurrence, {
                        autosetSurveys: true
                    }
                );
            }
            return defer;
        };
        return service;
    }

})();
